import request, { Method } from '../../../utils/request';

export default {
  async all(cartonId) {
    return request(`cartons/${cartonId}/guides`);
  },
  async scan(cartonId, guideNumber) {
    return request(`cartons/${cartonId}/guides/${guideNumber}/scan/`, Method.PUT);
  }
};
